export enum SurveyVariableConditionFilterDirectionEnum {
  ToAnswer = 'to_answer',
  ToAskAbout = 'to_ask_about',
}

export const SurveyVariableConditionFilterDirectionEnumLabels: Record<SurveyVariableConditionFilterDirectionEnum, string> = {
  [SurveyVariableConditionFilterDirectionEnum.ToAnswer]: 'Quién contesta',
  [SurveyVariableConditionFilterDirectionEnum.ToAskAbout]: 'Sobre quién se pregunta',
};
